'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _flattenN2 = require('./internal/_flattenN');

var _flattenN3 = _interopRequireDefault(_flattenN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Flattens an iterable `depth` levels.
 *
 * @example
 * // return List [ 1, List [ 2, 3 ], 4, 5, 6 ]
 * flattenN(1, List.of(List.of(1, List.of(2, 3)), List.of(4, 5, 6)));
 *
 * @param {number} depth
 * @param {Iterable} subject
 * @return {Iterable}
 */
exports.default = (0, _curry2.default)(_flattenN3.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/flattenN.js
// module id = 352
// module chunks = 0 1